import React, { useEffect, useId, useState } from 'react';
import { X } from 'lucide-react';
import { t } from '../i18n';
import './NotificationPopup.css';

function NotificationPopup({ notification, onClose }) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const titleId = useId();

  useEffect(() => {
    setDontShowAgain(false);
  }, [notification?.id]);

  if (!notification) return null;

  const close = () => onClose(dontShowAgain);

  return (
    <div className="notification-overlay" role="presentation" onClick={close}>
      <section
        className="notification-popup"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="notification-close"
          onClick={close}
          aria-label={t('notification.closeLabel')}
          title={t('common.close')}
        >
          <X size={20} aria-hidden="true" />
        </button>

        <div className="notification-heading">
          <span>{t('notification.eyebrow')}</span>
          <h2 id={titleId}>{notification.title || t('notification.defaultTitle')}</h2>
        </div>

        <p className="notification-message">{notification.message}</p>

        <label className="notification-dismiss-option">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={(event) => setDontShowAgain(event.target.checked)}
          />
          <span>{t('notification.dontShowAgain')}</span>
        </label>

        <button type="button" className="notification-primary" onClick={close}>
          {t('common.ok')}
        </button>
      </section>
    </div>
  );
}

export default NotificationPopup;
